import React from "react";
import { CheckCircle2, AlertCircle, Info, AlertTriangle, Clock } from "lucide-react";

const SEV = {
  info:    { color: "bg-slate-400",  icon: Info,         ring: "ring-slate-200" },
  success: { color: "bg-emerald-500", icon: CheckCircle2, ring: "ring-emerald-100" },
  warn:    { color: "bg-amber-500",   icon: AlertTriangle,ring: "ring-amber-100" },
  error:   { color: "bg-red-500",     icon: AlertCircle,  ring: "ring-red-100" },
};

function fmtTs(s) {
  if (!s) return "";
  try {
    const d = new Date(s);
    return d.toLocaleString("es-ES", { dateStyle: "short", timeStyle: "medium" });
  } catch {
    return s;
  }
}

const EVENT_LABELS = {
  received: "Recibido",
  mapped: "Mapeado a Hoomu",
  adapter_call: "Llamada al adaptador",
  policy_created: "Póliza creada",
  policy_queued: "Encolada",
  adapter_error: "Error del adaptador",
  idempotent_replay: "Solicitud idempotente",
  manual_retry: "Reintento manual",
  auto_retry: "Reintento automático",
  force_retry: "Reintento forzado",
  dead_letter: "Dead-letter",
  dead_letter_reset: "Dead-letter reseteado",
  queue_processed: "Cola procesada",
  cancellation_requested: "Cancelación",
};

export default function Timeline({ events = [] }) {
  if (!events.length) {
    return (
      <div className="text-sm text-slate-500 italic" data-testid="timeline-empty">
        Sin eventos registrados.
      </div>
    );
  }
  return (
    <ol className="relative border-l-2 border-slate-200 ml-3 space-y-5" data-testid="transaction-timeline">
      {events.map((e, idx) => {
        const sev = SEV[e.severity] || SEV.info;
        const Icon = sev.icon;
        const key = `${e.timestamp || "ts"}-${e.event}-${idx}`;
        return (
          <li key={key} className="ml-5">
            <span
              className={`absolute -left-[11px] flex items-center justify-center w-5 h-5 rounded-full ${sev.color} ring-4 ${sev.ring}`}
            >
              <Icon className="w-3 h-3 text-white" />
            </span>
            <div className="flex items-center justify-between gap-3">
              <p className="text-sm font-semibold text-slate-900">
                {EVENT_LABELS[e.event] || e.event}
              </p>
              <time className="text-xs font-mono text-slate-500 flex items-center gap-1">
                <Clock className="w-3 h-3" /> {fmtTs(e.timestamp)}
              </time>
            </div>
            {e.detail && (
              <p className="mt-0.5 text-xs text-slate-600 leading-relaxed">{e.detail}</p>
            )}
          </li>
        );
      })}
    </ol>
  );
}
